import { Form, Input } from "antd";

export default function Author(props) {
  return (
    <Form.Item {...props} name="author" className="w-full" label="Author">
      <Input className="w-full" placeholder="Enter author name" />
    </Form.Item>
  );
}
